import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { getFilterIds, removeAllDocumentsFilters } from "@tIntermatic/Services/DocumentsFilterService";

import { CustomApiHandler } from "@tIntermatic/Store/CustomHandlerCreator";

type Parameter = {};

type HandlerType = CustomApiHandler<Parameter>;

export const RemoveAllDocumentFilter: HandlerType = () => {
    removeAllDocumentsFilters();
};

export const DispatchSetDocumentFilters: HandlerType = ({ dispatch }) => {
    dispatch({
        type: "Components/DocumentListFilter/SetFilterIds",
        typeFilters: getFilterIds("doctype"),
        langFilters: getFilterIds("docLang"),
    });
};
export const chain = [RemoveAllDocumentFilter, DispatchSetDocumentFilters];

const removeAllDocumentFilters = createHandlerChainRunnerOptionalParameter(chain, {}, "RemoveAllDocumentFilters");
export default removeAllDocumentFilters;
